// extracted by mini-css-extract-plugin
export default {"gridCard":"MastheadCardGrid_gridCard__NvTpH","gridCardColumn":"MastheadCardGrid_gridCardColumn__s0nk+"};